import { useState } from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

export default function ChatBox({ messages = [] }) {
  const [open, setOpen] = useState(false);

  const unreadCount = messages.filter(m => !m.read).length;

  return (
    <div className="relative">
      {/* ✉️ Icône avec badge */}
      <button
        onClick={() => setOpen(!open)}
        className="relative p-2 rounded-md hover:bg-light-secondary/20 dark:hover:bg-dark-secondary/20"
      >
        <EnvelopeIcon className="h-6 w-6 text-white" />
        {unreadCount > 0 && (
          <span className="absolute top-0 right-0 bg-red-500 text-white text-xs rounded-full px-1.5 py-0.5">
            {unreadCount}
          </span>
        )}
      </button>

      {/* 📥 Dropdown des messages */}
      {open && (
        <div className="absolute right-0 mt-2 w-96 bg-light-surface dark:bg-dark-bg rounded-md shadow-lg ring-1 ring-black ring-opacity-5 z-50 flex flex-col">
          <div className="max-h-64 overflow-y-auto px-4 py-2 space-y-3 custom-scroll flex-1">
            {messages.length === 0 ? (
              <p className="text-sm text-gray-500 dark:text-gray-400">Aucun message reçu</p>
            ) : (
              messages.map((msg, idx) => (
                <div key={idx} className="border-b pb-2 text-light-text dark:text-dark-text">
                  <p className="font-semibold">{msg.sender}</p>
                  <p className="text-sm text-light-text/80 dark:text-dark-text/80">
                    {msg.content}
                  </p>
                  {msg.receivedAt && (
                    <p className="text-xs text-gray-400 mt-1">
                      Reçu le {new Date(msg.receivedAt).toLocaleDateString()}
                    </p>
                  )}
                </div>
              ))
            )}
          </div>

          {/* 🔗 Lien vers page de chat */}
          <div className="border-t px-4 py-2">
            <a href="/chat" className="text-sm text-light-primary dark:text-dark-primary hover:underline">
              Ouvrir le chat complet
            </a>
          </div>
        </div>
      )}
    </div>
  );
}
